"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_timezone_1 = __importDefault(require("moment-timezone"));
/**
 * The time zones supported by the application, keyed by strings like
 * "pacificStandardTime".
 */
exports.TimeZones = {
    hawaiianStandardTime: {
        id: 1,
        tzdbName: 'Pacific/Honolulu',
        bclName: 'Hawaiian Standard Time',
        standard: '-1000',
        daylight: '-1000',
    },
    alaskanStandardTime: {
        id: 2,
        tzdbName: 'America/Anchorage',
        bclName: 'Alaskan Standard Time',
        standard: '-0900',
        daylight: '-0800',
    },
    pacificStandardTime: {
        id: 3,
        tzdbName: 'America/Los_Angeles',
        bclName: 'Pacific Standard Time',
        standard: '-0800',
        daylight: '-0700',
    },
    mountainStandardTime: {
        id: 4,
        tzdbName: 'America/Denver',
        bclName: 'Mountain Standard Time',
        standard: '-0700',
        daylight: '-0600',
    },
    centralStandardTime: {
        id: 5,
        tzdbName: 'America/Chicago',
        bclName: 'Central Standard Time',
        standard: '-0600',
        daylight: '-0500',
    },
    easternStandardTime: {
        id: 6,
        tzdbName: 'America/New_York',
        bclName: 'Eastern Standard Time',
        standard: '-0500',
        daylight: '-0400',
    },
    atlanticStandardTime: {
        id: 7,
        tzdbName: 'America/Halifax',
        bclName: 'Atlantic Standard Time',
        standard: '-0400',
        daylight: '-0300',
    },
    westPacificStandardTime: {
        id: 8,
        tzdbName: 'Pacific/Port_Moresby',
        bclName: 'West Pacific Standard Time',
        standard: '+1000',
        daylight: '+1000',
    },
    utcMinus11: {
        id: 9,
        tzdbName: 'Etc/GMT+11',
        bclName: 'UTC-11',
        standard: '-1100',
        daylight: '-1100',
    },
    usMountainStandardTime: {
        id: 10,
        tzdbName: 'America/Phoenix',
        bclName: 'US Mountain Standard Time',
        standard: '-0700',
        daylight: '-0700',
    },
    newfoundlandStandardTime: {
        id: 11,
        tzdbName: 'America/St_Johns',
        bclName: 'Newfoundland Standard Time',
        standard: '-0330',
        daylight: '-0230',
    },
    utcPlus12: {
        id: 12,
        tzdbName: 'Etc/GMT-12',
        bclName: 'UTC+12',
        standard: '+1200',
        daylight: '+1200',
    },
    gmtStandardTime: {
        id: 13,
        tzdbName: 'Europe/London',
        bclName: 'GMT Standard Time',
        standard: '+0000',
        daylight: '+0000',
    },
    romanceStandardTime: {
        id: 15,
        tzdbName: 'Europe/Paris',
        bclName: 'Romance Standard Time',
        standard: '+0100',
        daylight: '+0100',
    },
};
/**
 * The time zones supported by the application, keyed by database ID.
 */
exports.TimeZonesById = new Map();
/**
 * The time zones supported by the application keyed by Tzdb name, such as
 * "America/Los_Angeles".
 */
exports.TimeZonesByTzdbName = new Map();
for (var _i = 0, _a = Object.values(exports.TimeZones); _i < _a.length; _i++) {
    var timeZone = _a[_i];
    exports.TimeZonesById.set(timeZone.id, timeZone);
    exports.TimeZonesByTzdbName.set(timeZone.tzdbName, timeZone);
}
// Guesses the browser's current time zone.
function guessBrowserTimeZone() {
    var tzdbName = moment_timezone_1.default.tz.guess();
    var timeZone = exports.TimeZonesByTzdbName[tzdbName];
    return timeZone || exports.TimeZones.pacificStandardTime;
}
exports.guessBrowserTimeZone = guessBrowserTimeZone;
